function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import MuiTextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';
import { changeAtBlur } from '../internal/change-at-blur.hoc';
import { Display } from '../internal/Display';
import { deprecated } from '../../utils/deprecated/deprecated.util';
import { InputButton } from './internal/input-button.component';
import { Typography } from '../../Typography'; // This needs to be a class component to prevent the following warning:
// 'Warning: Function components cannot be given refs. Attempts to access this ref will fail.'
// eslint-disable-next-line react/prefer-stateless-function

var TextFieldComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TextFieldComponent, _React$Component);

  var _super = _createSuper(TextFieldComponent);

  function TextFieldComponent() {
    _classCallCheck(this, TextFieldComponent);

    return _super.apply(this, arguments);
  }

  _createClass(TextFieldComponent, [{
    key: "render",
    value: function render() {
      var _classnames, _classnames2;

      var _this$props = this.props,
          button = _this$props.button,
          classesProp = _this$props.classes,
          e2e = _this$props['data-e2e'],
          defaultValue = _this$props.defaultValue,
          dirty = _this$props.dirty,
          disabled = _this$props.disabled,
          display = _this$props.display,
          endAdornment = _this$props.endAdornment,
          inputPropsProp = _this$props.inputProps,
          InputPropsProp = _this$props.InputProps,
          helperText = _this$props.helperText,
          label = _this$props.label,
          lineThroughIfDisabled = _this$props.lineThroughIfDisabled,
          onKeyDownProp = _this$props.onKeyDown,
          original = _this$props.original,
          rawProp = _this$props.raw,
          readOnly = _this$props.readOnly,
          select = _this$props.select,
          SelectPropsProp = _this$props.SelectProps,
          startAdornment = _this$props.startAdornment,
          textAlign = _this$props.textAlign,
          value = _this$props.value,
          others = _objectWithoutProperties(_this$props, ["button", "classes", "data-e2e", "defaultValue", "dirty", "disabled", "display", "endAdornment", "inputProps", "InputProps", "helperText", "label", "lineThroughIfDisabled", "onKeyDown", "original", "raw", "readOnly", "select", "SelectProps", "startAdornment", "textAlign", "value"]);

      var raw = rawProp || display;

      if (original) {
        deprecated("TextField: original prop does not match style guide and will be removed in next major release.");
      }

      var buttonAdornmentClass = classesProp.buttonAdornment,
          focusedClass = classesProp.focused,
          inputDisabledNotDisplayNotReadOnlyClass = classesProp.inputDisabledNotDisplayNotReadOnly,
          inputTransparentClass = classesProp.inputTransparent,
          inputLineThroughClass = classesProp.inputLineThrough,
          inputDisplaySelectNotDisabledClass = classesProp.inputDisplaySelectNotDisabled,
          inputOriginalClass = classesProp.inputOriginal,
          rootRawClass = classesProp.rootRaw,
          classes = _objectWithoutProperties(classesProp, ["buttonAdornment", "focused", "inputDisabledNotDisplayNotReadOnly", "inputTransparent", "inputLineThrough", "inputDisplaySelectNotDisabled", "inputOriginal", "rootRaw"]);

      var SelectProps = _objectSpread(_objectSpread({}, SelectPropsProp), {}, {
        SelectDisplayProps: {
          'data-e2e': select ? "".concat(e2e, "-select-input") : undefined
        },
        'data-e2e': select ? e2e : undefined
      }); // Native (DOM) input, textarea or our Display component


      var inputProps = _objectSpread(_objectSpread({}, inputPropsProp), {}, {
        'data-e2e': select ? undefined : e2e
      });

      var inputPropsStyle = inputProps.style;

      if (textAlign) {
        inputPropsStyle = _objectSpread(_objectSpread({}, inputPropsStyle), {}, {
          textAlign: textAlign
        });
      }

      inputProps = _objectSpread(_objectSpread({}, inputProps), {}, {
        style: inputPropsStyle
      }); // MUI Input component props

      var InputProps = _objectSpread(_objectSpread({}, InputPropsProp), {}, {
        readOnly: readOnly
      });

      if (display) {
        InputProps = _objectSpread(_objectSpread({}, InputProps), {}, {
          disableUnderline: true,
          inputComponent: Display
        });
      }

      if (readOnly) {
        InputProps = _objectSpread(_objectSpread({}, InputProps), {}, {
          disableUnderline: true
        });
      }

      if (startAdornment || dirty) {
        var adornment = startAdornment;

        if (dirty && !display) {
          adornment =
          /*#__PURE__*/
          React.createElement(Tooltip, {
            title: "This value has been changed from the default value."
          },
          /*#__PURE__*/
          React.createElement("span", null,
          /*#__PURE__*/
          React.createElement(Typography, null, startAdornment, "\xA0!")));
        }

        var prefix = createInputAdornment('start', adornment);
        InputProps = _objectSpread(_objectSpread({}, InputProps), {}, {
          startAdornment: prefix
        });
      }

      if (endAdornment) {
        var suffix = createInputAdornment('end', endAdornment);
        InputProps = _objectSpread(_objectSpread({}, InputProps), {}, {
          endAdornment: suffix
        });
      }

      var buttonOnClick;

      if (button && !display) {
        var _button$props = button.props,
            onClick = _button$props.onClick,
            disabledButton = _button$props.disabled,
            children = _button$props.children;
        var buttonAdornment =
        /*#__PURE__*/
        React.createElement(InputAdornment, {
          position: "end",
          classes: {
            positionEnd: buttonAdornmentClass
          }
        },
        /*#__PURE__*/
        React.createElement(InputButton, {
          "data-e2e": "".concat(e2e, "-button"),
          onClick: onClick,
          disabled: disabledButton || disabled
        }, children));
        InputProps = _objectSpread(_objectSpread({}, InputProps), {}, {
          endAdornment: buttonAdornment
        });
        buttonOnClick = disabledButton ? undefined : onClick;
      } else {
        buttonOnClick = undefined;
      }

      var InputPropsClasses = InputProps.classes ? InputProps.classes : {};
      InputProps = _objectSpread(_objectSpread({}, InputProps), {}, {
        classes: _objectSpread(_objectSpread({}, InputPropsClasses), {}, {
          root: classnames(InputPropsClasses.root, (_classnames = {}, _defineProperty(_classnames, inputOriginalClass, original && !display), _defineProperty(_classnames, inputTransparentClass, display || readOnly), _classnames)),
          disabled: classnames(InputPropsClasses.disabled, (_classnames2 = {}, _defineProperty(_classnames2, inputDisabledNotDisplayNotReadOnlyClass, disabled && !display && !readOnly), _defineProperty(_classnames2, inputLineThroughClass, disabled && lineThroughIfDisabled), _defineProperty(_classnames2, inputDisplaySelectNotDisabledClass, display && !disabled), _classnames2)),
          focused: classnames(InputPropsClasses.focused, focusedClass)
        })
      });

      var onKeyDown = function onKeyDown(event) {
        if (onKeyDownProp) {
          onKeyDownProp(event);
        }

        if (!event.defaultPrevented && buttonOnClick && !event.altKey && !event.shiftKey && !event.ctrlKey && event.keyCode === 13) {
          event.preventDefault();
          buttonOnClick(event);
        }
      };

      return (
        /*#__PURE__*/
        React.createElement(MuiTextField, _extends({
          classes: _objectSpread(_objectSpread({}, classes), {}, {
            root: classnames(classes.root, _defineProperty({}, rootRawClass, raw))
          }),
          defaultValue: normalizeValue(defaultValue),
          disabled: disabled || display && select,
          helperText: raw ? undefined : helperText,
          InputLabelProps: {
            shrink: true
          },
          inputProps: inputProps // eslint-disable-next-line react/jsx-no-duplicate-props
          ,
          InputProps: InputProps,
          label: raw ? undefined : label,
          onKeyDown: onKeyDown,
          select: select,
          SelectProps: SelectProps,
          value: normalizeValue(value)
        }, others))
      );
    }
  }]);

  return TextFieldComponent;
}(React.Component); // Keep undefined for uncontrolled but use null for controlled mode
// material-ui assumes uses both undefined and null for uncontrolled


function normalizeValue(value) {
  return value === null ? '' : value;
}

function createInputAdornment(position, content) {
  if (content && content.props && content.props.position) {
    deprecated("TextField: only pass the content in startAdornment or endAdornment.\nNo need to pass an InputAdornment element.");
    return content;
  }

  return (
    /*#__PURE__*/
    React.createElement(InputAdornment, {
      position: position
    }, content)
  );
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `raw={true}` or `display={true}` */
    rootRaw: {
      margin: 0
    },

    /* Styles applied to the input element if `original={true}` and not display */
    inputOriginal: {
      backgroundColor: theme.palette.grey[200]
    },

    /* Styles applied to the input element if `disabled={true}` and not display and not readOnly */
    inputDisabledNotDisplayNotReadOnly: {
      backgroundColor: theme.palette.grey[300]
    },

    /* Styles applied to the input element 'disabled' class if `display={true}` and select={true}` */
    inputDisplaySelectNotDisabled: {
      color: theme.palette.grey[800]
    },

    /* Styles applied to the input element if `disabled={true}` and `lineThroughIfDisabled={true}` */
    inputLineThrough: {
      textDecoration: 'line-through'
    },

    /* Styles applied to the input element if `disabled={true}` or `readOnly={true}` */
    inputTransparent: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      '&$focused': {
        backgroundColor: 'transparent',
        borderColor: 'transparent'
      }
    },

    /* Styles applied to the root element if the component is focused */
    focused: {},

    /* Button end adornment */
    buttonAdornment: {
      marginRight: '-1px'
    }
  };
};

export var testPort = {
  createInputAdornment: createInputAdornment,
  normalizeValue: normalizeValue
};
export var TextField = withStyles(styles)(changeAtBlur(TextFieldComponent));